__turbopack_context__.v({
  "wrapper": "EventTitle-module-scss-module__-Atj6a__wrapper",
});
